import React, { useContext, useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { useViewerContextQuery } from './ViewerContext.generated';
import type { ViewerContext_UserFragment } from './ViewerContext.generated';

const context = React.createContext<ViewerContext_UserFragment | null>(null);

export const ViewerConsumer = context.Consumer;
export const ViewerProvider = context.Provider;

interface ViewerProviderQueryProps {
    children: React.ReactNode;
}

export function ViewerProviderQuery({ children }: ViewerProviderQueryProps) {
    const { loading, error, data } = useViewerContextQuery();

    useEffect(() => {
        if (data?.viewer) {
            Bugsnag.addMetadata('viewer', {
                userId: data.viewer.id,
            });
        } else {
            Bugsnag.addMetadata('viewer', {
                userId: null,
            });
        }
    }, [data]);

    if (loading) return null;
    if (error) throw error;
    if (!data) throw new Error('missing viewer data');

    return <context.Provider value={data.viewer}>{children}</context.Provider>;
}

export function useViewer(): ViewerContext_UserFragment | null {
    return useContext(context);
}
